<!--  section  -->
<section class="parallax-section single-par" data-scrollax-parent="true">
    <div class="bg par-elem " style="background-image: url('../../assets/images/bg/3.jpg'); translate:'30%'"></div>
    <div class="overlay op7"></div>
    <div class="container">
        <div class="section-title center-align big-title">
            <h2><span>Shipping and Delivery Policy</span></h2>
            <span class="section-separator"></span>
            <div class="breadcrumbs fl-wrap"><a href="/">Home</a><span>Shipping and Delivery</span></div>
        </div>
    </div>
    <div class="header-sec-link">
        <a href="javascript:void(0);" class="custom-scroll-link"><i class="fal fa-angle-double-down"></i></a>
    </div>
</section>
<!--  section  end-->
<!--section  -->
<section class="no-top-padding-sec" data-scrollax-parent="true">
    <div class="container">
        <div class="user-profile-header_content">
            <div class="ab_text-title fl-wrap">
                <h4>Shipping and Delivery Policy </h4>
                <span class="section-separator fl-sec-sep"></span>
            </div>
            <p>a. The product booked by the Buyer, Buyer order send to Seller and Seller either through his own logistics or through 3rd party Logistics Provider.</p>
            <p>b. The product will be delivered within 5-7 business working days. </p>
            <p>c. There will be logistics charges applicable based on the seller or type of product purchased.</p>
            <p>e. Yes, the Consumer Protection Act of 2019 allows buyers to return defective, delayed, or mismatched items for a refund within 15 days of purchase. The items must be returned in their original packaging, undamaged, and without any size or form changes.</p>
        </div>
    </div>
</section>
<!--section end-->